import { motion } from 'framer-motion';
import { ToggleSwitch } from './ToggleSwitch';
import { sectionVariants } from './settings.animations';
import styles from '../Settings.module.css';

export interface DisplaySectionProps {
  showRevisionMarks: boolean;
  sketchyLineStyle: boolean;
  onShowRevisionMarksChange: (value: boolean) => void;
  onSketchyLineStyleChange: (value: boolean) => void;
}

export function DisplaySection({
  showRevisionMarks,
  sketchyLineStyle,
  onShowRevisionMarksChange,
  onSketchyLineStyleChange,
}: DisplaySectionProps) {
  return (
    <motion.section
      className={styles.section}
      variants={sectionVariants}
      aria-labelledby="display-heading"
    >
      <div className={styles.sectionHeader}>
        <span className={styles.sectionIcon} aria-hidden="true">
          #
        </span>
        <h2 id="display-heading" className={styles.sectionTitle}>
          Display
        </h2>
      </div>

      <div className={styles.settingRow}>
        <div className={styles.settingInfo}>
          <p className={styles.settingLabel}>Show Revision Marks</p>
          <p className={styles.settingDesc}>
            Display the Visual Chaos System - strikethroughs, ghost blocks, and revision history
            that mimics paper planning
          </p>
        </div>
        <ToggleSwitch
          checked={showRevisionMarks}
          onChange={onShowRevisionMarksChange}
          label="Show revision marks"
        />
      </div>

      <div className={styles.settingRow}>
        <div className={styles.settingInfo}>
          <p className={styles.settingLabel}>Sketchy Line Style</p>
          <p className={styles.settingDesc}>Use hand-drawn looking lines for a more organic feel</p>
        </div>
        <ToggleSwitch
          checked={sketchyLineStyle}
          onChange={onSketchyLineStyleChange}
          label="Enable sketchy line style"
        />
      </div>
    </motion.section>
  );
}
